(function () {
  ("use strict");

  // Anchor block
  const anchorBlock = document.querySelectorAll(".anchor-links__list");
  const anchorLinks = document.querySelectorAll(".anchor-links__anchor");

  if (anchorBlock.length) {
    // Build anchor block list
    Array.from(anchorLinks).forEach((item) => {
      anchorBlock[0].insertAdjacentHTML(
        "beforeend",
        "<li class='anchor-links__item'><a href='#" +
          item.getAttribute("id") +
          "' class='anchor-links__link'>" +
          item.getAttribute("data-anchor-title") +
          "</a></li>"
      );
    });
  }
})();
